import { render, staticRenderFns } from "./PositionOfLetters.vue?vue&type=template&id=1c679888&scoped=true"
import script from "./PositionOfLetters.vue?vue&type=script&lang=js"
export * from "./PositionOfLetters.vue?vue&type=script&lang=js"
import style0 from "./PositionOfLetters.vue?vue&type=style&index=0&id=1c679888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c679888",
  null
  
)

export default component.exports